import React, { useRef, useState } from "react";
import Navbar from "../../Components/Navbar";
import NavbarMobile from "../../Components/NavbarMobile";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Form.scss";
import { AiFillGithub, AiFillLinkedin, AiOutlineTwitter } from "react-icons/ai";

export default function Contact() {
  const [sending, setSending] = useState(false);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    setSending(true);

    emailjs
      .sendForm(
        "service_fc5fmqr",
        "template_wkms8ns",
        form.current,
        "fWvIZIaviUtfexktP"
      )
      .then(
        (result) => {
          setSending(false);
          form.current.reset();
          toast.success("Your Request is sent Succesfully!!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        },
        (error) => {
          setSending(false);

          toast.error("Something went wrong. Try again later.", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      );
  };

  return (
    <div className="page">
      <Navbar className="desktop" />
      <NavbarMobile className="mobile" />
      <div className="content">
        <ToastContainer />
        <h1>CONTACT</h1>

        <hr></hr>

        <div className="formContainer">
          <form ref={form} onSubmit={sendEmail} className="form">
            <input
              id="name"
              type="text"
              name="name"
              placeholder="Name"
              required
            />
            <br />
            <input
              id="email"
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <br />
            <textarea
              id="msg"
              placeholder="Message"
              name="msg"
              rows="10"
              required
            ></textarea>
            <br />
            {sending ? (
              <button
                type="submit"
                className="bg"
                disabled={true}
                style={{ backgroundColor: "#737373" }}
              >
                Submit
              </button>
            ) : (
              <button type="submit" className="bg form-btn">
                Submit
              </button>
            )}
          </form>
        </div>

        <div
          className="links"
          style={{
            width: "150px",
            marginLeft: "20vw",
            justifyContent: "space-between",
            marginTop: "5vh",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <a href="https://www.linkedin.com/in/dushyanth-gali/" target="_blank">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#011f4c",
                fontFamily: "LemonBold",
                fontSize: "14px",
                gap: "5px",
              }}
            >
              <AiFillLinkedin size={25} color="#011f4c" />
              LinkedIn
            </div>
          </a>

      <a href="https://twitter.com/iam_dushu" target="_blank">
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#011f4c",
                fontFamily: "LemonBold",
                fontSize: "14px",
                gap: "5px",
              }}
              className="cnc-btn"
            >
              <AiOutlineTwitter size={25} color="#011f4c" />
              Twitter / X
            </div>
       </a>

          <a
  className="libutton"
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "7px",
    textAlign: "center",
    outline: "none",
    textDecoration: "none",
    color: "#ffffff",
    width: "200px",
    height: "32px",
    borderRadius: "16px",
    backgroundColor: "#011f4c",
    fontSize: "14px",
    fontWeight: "bold",
    fontFamily: '"SF Pro Text", Helvetica, sans-serif',
  }}
  href="https://www.linkedin.com/comm/mynetwork/discovery-see-all?usecase=PEOPLE_FOLLOWS&followMember=dushyanth-gali"
  target="_blank"
>
  Follow on LinkedIn
</a>

        </div>
      </div>
    </div>
  );
}
